/* eslint-disable react/prop-types */
import { colors, strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import {
  FlexContainers,
  IconButton,
  Switcher,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../../components";
import { CellWrapper } from "../../../../../components/Table/styled";
import RadioInput from "../../../../../components/RadioGroup/RadioInput";
import { LanguageNameWrapper } from "./styled";

export const LocalizationsTableColumns = [
  {
    Header: strCode.NAME_TITLE,
    accessor: "fullName",
    Cell: ({ cell, cellWidth3, searchedText }) => {
      return (
        <CellWrapper width={`${cellWidth3}px`}>
          <LanguageNameWrapper Container={FlexContainers.FlexRowStart} gap={16}>
            <WrapperContainer width={"100%"}>
              <TextOverflowWrapper
                highlightedText={searchedText}
                style={{
                  color: colors.RAISIN_70
                }}>
                {cell?.value}
              </TextOverflowWrapper>
            </WrapperContainer>
          </LanguageNameWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.DEFAULT_QUESTION,
    accessor: "isDefault",
    Cell: ({ cell, callbackFn1: onToggleValue, callbackFn2: onSelectDefault }) => {
      const originalRow = cell.row.original;
      const { isSelected, isDefault, name } = originalRow;

      return (
        <CellWrapper width="100%">
          <LanguageNameWrapper
            Container={FlexContainers.FlexRowStart}
            gap={16}
            width="100%"
            ph={16}>
            <WrapperContainer width="100%">
              <IconButton
                tooltipComponent={
                  !isSelected ? (
                    <WrapperContainer maxWidth={217}>
                      {t(strCode.DEFAULT_LANGUAGE_WRANING_MSG)}
                    </WrapperContainer>
                  ) : null
                }>
                <RadioInput
                  id={name}
                  name={name}
                  checkedId={isDefault ? name : null}
                  disabled={!isSelected}
                  onCheck={onSelectDefault}
                />
              </IconButton>
            </WrapperContainer>

            <WrapperContainer>
              <Switcher id={name} checked={isSelected} onSwitch={() => onToggleValue(name)} />
            </WrapperContainer>
          </LanguageNameWrapper>
        </CellWrapper>
      );
    }
  }
];
